import Vue from 'vue'
import Vuex from 'vuex'
import {s3, BUCKET_NAME} from '@/service/bucket.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    bucket: s3,
    gallery: {
      'restauri-interni': [],
      'restauri-esterni': [],
      'decori-interni': [],
      'decori-esterni': []
    }
  },
  mutations: {},
  actions: {
    loadGallery({ state }) {
      const sections = [ 'restauri-interni', 'restauri-esterni', 'decori-interni', 'decori-esterni' ]

      sections.forEach(key => {
        state.bucket.listObjects(
            { Prefix: `${key}` },
            function(err, data) {
              if (err) {
                console.log(err)
              } else {
                const bucketUrl = this.request.httpRequest.endpoint.href + BUCKET_NAME  + "/";

               const albumKeys = [ ...new Set(data.Contents.filter((element) => element.Size !== 0 && element.Key !== `${key}/`).
                  map(element => `${key}/${element.Key.split('/')[1]}`)) ]

                albumKeys.forEach(albumKey => {
                  let album = { key: albumKey, content: [] }
                  state.gallery[key] = [...state.gallery[key], album ]
                  let index = state.gallery[key].length - 1

                  let metadataKey
                  data.Contents.filter(elem => elem.Key.startsWith(albumKey + '/')).forEach(elem => {
                    if (elem.Key.endsWith('info.json')) {
                      metadataKey = elem.Key
                      fetch(bucketUrl + metadataKey).then(ris => ris.json()).then(data => {
                        Vue.set(state.gallery[key][index], "title", data.title)
                        Vue.set(state.gallery[key][index], "desc", data.desc)
                      })
                    } else if (elem.Key.endsWith('tn.jpg')) {
                        album.thumbnail = bucketUrl + elem.Key
                    } else if (elem.Size > 0) {
                      album.content.push(bucketUrl + elem.Key)
                    }
                  })

                })
              }
            }
        )
      })
    }
  },
  modules: {
  }
})
